import { render, staticRenderFns } from "./highlighted-products-icon.vue?vue&type=template&id=d6332fa2&functional=true&"
import script from "./highlighted-products-icon.vue?vue&type=script&lang=js&"
export * from "./highlighted-products-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports